import { safeStorage } from "../../../../helpers/safeStorage"

const CODE_KEY = "discountCodeParam"
const AT_KEY = "discountCodeParamAt"
// Ein Flyer-Link gilt einen Tag lang für jede Buchung (zweites Kind, zweiter Kurs), danach nicht mehr vorbelegen.
const LINK_CODE_TTL_MS = 24 * 60 * 60 * 1000

export const rememberLinkDiscountCode = (code: string, now = Date.now()) => {
    safeStorage.setItem(CODE_KEY, code)
    safeStorage.setItem(AT_KEY, String(now))
}

// Jede eigene Aktion im Code-Feld (einlösen, entfernen) beendet den Link-Code, sonst belegt er die nächste Buchung wieder vor.
export const forgetLinkDiscountCode = () => {
    safeStorage.removeItem(CODE_KEY)
    safeStorage.removeItem(AT_KEY)
}

export const readLinkDiscountCode = (now = Date.now()): string | null => {
    const code = safeStorage.getItem(CODE_KEY)
    const at = Number(safeStorage.getItem(AT_KEY))

    if (code && at > 0 && now - at < LINK_CODE_TTL_MS) {
        return code
    }
    // Abgelaufen oder aus einem älteren Bundle ohne Zeitstempel.
    forgetLinkDiscountCode()
    return null
}

/**
 * Code für eine neue Buchung: Ein lebender Flyer-Link gewinnt, auch gegen einen alten Code desselben Kurses (ein frisch
 * geöffneter Link soll wirken). Hat der Kunde selbst einen Code eingelöst oder entfernt, ist der Link vergessen und
 * derselbe Kurs behält seinen Code.
 */
export const discountCodeForCourse = (
    courseId: string,
    previous: { courseId?: string | null; discountCode?: string | null } | null | undefined,
    now = Date.now()
): string => readLinkDiscountCode(now) || (previous?.courseId === courseId && previous.discountCode) || ""
